import React, { Component } from "react";
import { Route, Switch } from "react-router-dom";
import About from "../layout/About";
import NavbarLayout from "../layout/Navbar";
import NotFound from "../layout/NotFound";
import TablesP from "../tables/TablesP";
import TablesAz from "../tables/TablesAz";
import TablePimaWeekly from "../tables/TablePimaWeekly";
import TableArizonaWeekly from "../tables/TableArizonaWeekly";
import WeeklyAvg from "../graphs/WeeklyAvg";
import MonthlyInfections from "../graphs/MonthlyInfections";
import VaccinationPima from "../vaccination/VaccinationPima";
import VaccinationMaricopa from "../vaccination/VaccinationMaricopa";
import VaccinationArizona from "../vaccination/VaccinationArizona";
import VaccinationComparison from "../vaccination/VaccinationComparison";

export default class Routes extends Component {
  render() {
    return (
      <>
        <NavbarLayout />
        <div className="container mb-4">
          <Switch>
            <Route exact path="/" component={TablesP} />
            <Route exact path="/pima-weekly" component={TablePimaWeekly} />
            <Route
              exact
              path="/pima-monthly-infections"
              component={MonthlyInfections}
            />
            <Route exact path="/pima-weekly-tendency" component={WeeklyAvg} />
            <Route
              exact
              path="/arizona-weekly"
              component={TableArizonaWeekly}
            />
            <Route exact path="/arizona" component={TablesAz} />
            <Route exact path="/vaccination-pima" component={VaccinationPima} />
            <Route
              exact
              path="/vaccination-maricopa"
              component={VaccinationMaricopa}
            />
            <Route
              exact
              path="/vaccination-arizona"
              component={VaccinationArizona}
            />
            <Route
              exact
              path="/vaccination-comparison"
              component={VaccinationComparison}
            />
            <Route exact path="/about" component={About} />
            <Route component={NotFound} />
          </Switch>
        </div>
      </>
    );
  }
}
